<template>
    <div class="portfolioItemGrid"
         v-if="this.gridItemList !== undefined && this.gridItemList.length > 0">
      <div class="portfolioItemGridRow">
        <div class="portfolioItemGridColumn"
          v-for="(gridItems , index) in this.gridItemList"
            :key="index"
        >
          <div
            class="portfolioItem"
            v-for="(gridItem , _index) in gridItems"
            :key="_index"
            @mouseenter="overlayOn(gridItem.num , $event)"
            @mouseleave="overlayOff(gridItem.num , $event)"
          >
            <portfolio-overlay
              :portfolio="gridItem"
              :ref="'overlay'+gridItem.num"
            />
            <img
              class="thumbnailImage"
              :src="`//${gridItem.savedUrl}thumbnail/${gridItem.thumbnailFileName}`"
            >
          </div>

        </div>
      </div>
      <!--<div
        class="portfolioItemOverlapBackground"
      >
        {{portfolio.title}}
        <img class="thumbnailImage" :src="`//${portfolio.savedUrl}thumbnail/${portfolio.thumbnailFileName}`"/>
      </div>-->
      <!--<div
        class="portfolioItemContentWrap"
        :style="{background: `url(//${portfolio.savedUrl}thumbnail/${portfolio.thumbnailFileName})`}"
      >

      </div>-->

      <!--{{this.portfolios}}-->
    </div>
</template>

<script>
    import PortfolioOverlay from "./PortfolioOverlay";

    export default {
        name: "portfolio-item" ,
        props : ['portfolios'],
        components : {
          PortfolioOverlay

        },
        watch : {
          portfolios (newVal , oldVal) {
            //console.log('portfolios ' , this.portfolios)
            //console.log('Prop changed: ', newVal, ' | was: ', oldVal)


            if(this.portfolios.length > 0){

              const portfolioHorizontalMaxView = 3;
              const _gridItemList = [];

              for(let i = 0 ; i < portfolioHorizontalMaxView; i++){
                const columnItems =
                  newVal.filter( (n , idx ) => idx % portfolioHorizontalMaxView === i);

                _gridItemList[i] =
                  columnItems;
              }
              this.gridItemList = _gridItemList;
            }
            else{
              this.gridItemList = [];
            }

          }
        },
        data () {
          return {
            gridItemList : [],
            mobile : false ,
          }
        } ,
        methods : {
          overlayOn (index , evt) {
            //console.log(index);
            this.$refs['overlay'+index][0].view = true;

          },
          overlayOff (index , evt) {
            //console.log('asdfasdf');
            evt.preventDefault();
            if(this.$refs['overlay'+index][0].modalState)
              return null;

            if(this.$refs['overlay'+index][0].mobile)
              return null;

            this.$refs['overlay'+index][0].view = false;
          },
        },
        created () {

        },
        mounted () {
          //console.log('portfolios ' , this.portfolios)
        },

    }
</script>

<style scoped lang="scss">
  @import '@/styles/Global.scss';

  .portfolioItemGrid{
    /*img.thumbnailImage {
      width:100%;
      height:auto;
    }*/
    .portfolioItemGridRow {
      display: -ms-flexbox; /* IE10 */
      display: flex;
      -ms-flex-wrap: wrap; /* IE10 */
      flex-wrap: wrap;
      padding: 0 0.5rem;
      .portfolioItemGridColumn {
        -ms-flex: calc(100%/3.12); /* IE10 */
        flex: calc(100%/3.12);
        max-width: calc(100%/3.12);
        padding: 0 0.5rem;
        @include respond-to('large') {
          -ms-flex: calc(100%/2.12); /* IE10 */
          flex: calc(100%/2.12);
          max-width: calc(100%/2.12);
        }
        @include respond-to('medium') {
          -ms-flex: 100%; /* IE10 */
          flex: 100%;
          max-width: 100%;
        }
          .portfolioItem{
            margin-top:8px;
            position: relative;
            border-radius: 13px;
            overflow: hidden;
            >img.thumbnailImage {
              vertical-align: middle;
              width:100%;
            }
          }

      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/menu/Portfolio/PortfolioItem.vue